import React from 'react';
import { ConfigTitle } from './config-title';
import { VidebisButton } from '../../shared/components/videbis-button/videbis-button';
import { DebugBox } from '../../shared/components/debug-box/debug-box';
import { StringMap } from '../../shared/util/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons/faPlusCircle';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons/faMinusCircle';
import '../styles/gamma-correction.scss';
import { isEnter } from '../../shared/util/functions';

library.add(faMinusCircle);
library.add(faPlusCircle);

interface Props {
    onPress: () => void;
    onBack: () => void;
    color: string;
    gammaFactor: number;
    onColorChange: (decrease?: boolean) => void;
}

function generateField(solidBlockColor: string): JSX.Element {
    const rows: JSX.Element[] = [];
    const rowsNum = 200;
    const rowHeight = '2px';

    const fieldWidth = '600px';
    const fieldHeight = '400px';

    const solidBlockSize = '150px';

    const solidBlockTopDistance = '125px';
    const solidBlockLeftDistance = '225px';

    for (let i = 0, nextIsBlack = true; i < rowsNum; ++i, nextIsBlack = !nextIsBlack) {
        rows.push(
            <div
                key={`row_${i}`}
                className={`field__row ${nextIsBlack ? 'black' : 'white'}`}
                style={{ height: rowHeight }}
            />
        );
    }

    return (
        <div className={'gamma-calibration__field'} style={{ width: fieldWidth, height: fieldHeight }}>
            {rows}
            <div
                className={'field__solid-block'}
                style={{
                    backgroundColor: solidBlockColor,
                    width: solidBlockSize,
                    height: solidBlockSize,
                    top: solidBlockTopDistance,
                    left: solidBlockLeftDistance
                }}
            />
        </div>
    );
}

function getDebugContent(currentColor: string, gammaFactor: number): StringMap<string> {
    return {
        'current color': currentColor,
        'gamma factor': gammaFactor.toString()
    };
}

export const GammaCorrection: React.FunctionComponent<Props> = props => {
    const field = generateField(props.color);
    return (
        <section className={'gamma-calibration--wrapper limit-width'}>
            <div className='gamma-calibration__description-section'>
                <ConfigTitle
                    title={'Kalibrierung'}
                    subtitle={
                        '2. Schritt: Kontrast einstellen '
                    }/>
                <p className={'calibration__description standard-text'}>
                    Schauen Sie möglichst gerade auf den Bildschirm und stellen Sie <br/>den Kontrast so ein,
                    dass das Kästchen in der Mitte kaum sichtbar ist.
                </p>
            </div>
            <div className='gamma-calibration__calibration-section'>
                <div tabIndex={0}
                     className={'gamma-section__icon gamma-section__minus'}
                     aria-label={'dünkler'}
                     onKeyPress={evt => isEnter(evt) && props.onColorChange(true)}
                     onClick={() => props.onColorChange(true)}>
                    <FontAwesomeIcon icon={'minus-circle'}/>
                </div>
                {field}
                <div tabIndex={0}
                     className={'gamma-section__icon gamma-section__plus'}
                     aria-label={'heller'}
                     onKeyPress={evt => isEnter(evt) && props.onColorChange()}
                     onClick={() => props.onColorChange()}>
                    <FontAwesomeIcon icon={'plus-circle'}/>
                </div>
            </div>
            <div className={'calibration__buttons'}>
                <VidebisButton onPress={props.onBack} text={'Zurück'} bgColor={'#ffffff'} txtColor={'#0c23fb'}/>
                <VidebisButton onPress={props.onPress}/>
            </div>
            <DebugBox content={getDebugContent(props.color, props.gammaFactor)}/>
        </section>
    );
};
